import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/core/services/courses-service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { UniversityService } from 'src/app/core/services/university.service';
import { CourseProgram, LearningAreasString } from 'src/app/model/course-program';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';
import { OperationResult } from '@tb/auth';
import {MatDialog} from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { LoadingService } from 'src/app/core/services/loading.service';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ms-course-detail',
  templateUrl: './course-detail.component.html',
  styleUrls: ['./course-detail.component.scss']
})
export class CourseDetailComponent implements OnInit {
  course: CourseProgram = new CourseProgram();
  isFav: boolean;
  isFavourite: boolean;
  trainingPlan: boolean;
  courseCopiedText: string;
  authorizationStored;
    authorizationProperties: AuthorizationProperties;
    public isLoading: boolean = false;

  constructor(
    public universityService: UniversityService,
    private navigateService: NavigateService,
    private courseService: CoursesService,
    private configurationService: ConfigurationService,
    private router: Router,
    private loginService: LoginService,
    public dialog: MatDialog,
    private variable: TranslatedVariables,
    public loadingService: LoadingService,
    public snackBar: MatSnackBar,
    public translateService: TranslateService,
    private location: Location
  ) {
    this.authorizationStored = this.loginService.getauthinfo();
    this.authorizationProperties = JSON.parse(this.authorizationStored);
   }

  async ngOnInit(){


    try {
      this.isLoading = true;

      let res = await this.translateService.get(["COMMONS.COURSECOPIED"]).toPromise();
      this.courseCopiedText = res["COMMONS.COURSECOPIED"] ?? "";

      if(!this.navigateService.getLocalStorageData<CourseProgram>('selectedCourse')) throw new Error()
      this.course = this.navigateService.getLocalStorageData<CourseProgram>('selectedCourse');
      this.trainingPlan = this.navigateService.getLocalStorageData<boolean>('trainingPlans') ?? false;
      this.isLoading = false;
    }
    catch(err){
      this.router.navigate(['/mago-university/mago-courses'])
    }

  }

  shareCourse(courseMaterial: string){
    navigator.clipboard.writeText(this.courseService.getCourseLink(courseMaterial));
    this.snackBar.open(this.courseCopiedText, null, {
      duration: 3000
    });
  }

  getAreaString(areaCode: number): string {
    return LearningAreasString[`AREA${areaCode.toString()}`]
  }

  async addRemoveFavourite()
  {
    this.isLoading = true;
    this.loadingService.setLoading(this.isLoading);
    let result: OperationResult = await this.configurationService.isFavouriteCourse(this.authorizationProperties.accountName,this.course.CourseName);
    this.isFavourite = result.Result;
    if (this.isFavourite)
    {
      this.configurationService.DeleteFavouriteCourse(this.authorizationProperties.accountName,this.course.CourseName);
      let result: OperationResult = await this.configurationService.isFavouriteCourse(this.authorizationProperties.accountName,this.course.CourseName);
      this.isFavourite = result.Result;
      let btn = document.getElementById("favouriteButton");
      btn.className = "noFavouriteStarStyle";
      this.dialog.open(AlertDialogComponent, {
        data: {Message: this.variable.course_delete_favourite},
      });
    }
    else
    {
      this.configurationService.AddFavouriteCourse(this.authorizationProperties.accountName,this.course.CourseName);
      let result: OperationResult = await this.configurationService.isFavouriteCourse(this.authorizationProperties.accountName,this.course.CourseName);
      this.isFavourite = result.Result;
      let btn = document.getElementById("favouriteButton");
      btn.className = "favouriteStarStyle";
      this.dialog.open(AlertDialogComponent, {
        data: {Message: this.variable.course_add_favourite},
      });
    }
    this.isLoading = false;
    this.loadingService.setLoading(this.isLoading);
  }

  async openCourse(courseMaterial: string){
    try {
      let courseTokenRes = await this.courseService.generateCorseToken(courseMaterial)
      console.log(courseTokenRes);
      if(courseTokenRes.Result && courseTokenRes.Content)
        this.courseService.openCourse(courseMaterial, courseTokenRes.Content)
      else
        throw new Error("Error during open course")
    } catch (err) {
      alert(err?.message)
    }
  }

  returnToList(){
    if(this.trainingPlan && !this.course.TrainingPlan){
      this.navigateService.setLocalStorageData('selectedCourse', JSON.stringify(this.navigateService.getLocalStorageData<CourseProgram>("trainingPlan")))
      this.router.navigate(['/mago-university/mago-courses/course-detail'])
    }
    else {
      this.router.navigate(['/mago-university/mago-courses'])
    }
  }
}
